import TimeTableEdit from "@/controllers/timetable/timetable-edit.js";
import axios from "axios";
import store from "@/store";
import {
  required
} from "vuelidate/lib/validators";

export default {
  extends: TimeTableEdit,
  name: 'timetableEdit',

  data() {
    return {
      ...TimeTableEdit.data.call(this),
      templateArr: [],
      template_id: null,
      original_acd_year: null,
      original_class_id: null,
      original_template_id: null,
      isTemplateChanged: false,
      days: [],
      time: [],
      subjectRows: [],
      teacherRows: [],
      teacherOptionsByCell: {},
      teacherMap: {},
      timeTableData: [],
      selectedSubjects: [],
      subjectChangeCounter: 0,
    };
  },

  validations() {
    return {
      ...TimeTableEdit.validations,
      template_id: { required }
    };
  },

  methods: {
    // Override methods from parent timetable-edit.js to avoud unnecessary API calls
    getTimetableMeta() {},
    getTimeTableDetail() {},

    getTemplates() {
      this.isLoading = true;
      axios.get('/timetableMeta/templates', {
        params: {
          campus_id: store.state.user.campus_id,
        }
      })
        .then(res => {
          let $defaultSelectOption = [{
            'id': 0,
            'text': 'Select Template'
          }];
          const templates = res.data.templates.map(t => ({
            'id': t.id,
            'text': t.name
          }));
          this.templateArr = $defaultSelectOption.concat(templates);
          this.isLoading = false;
        })
        .catch((error) => {
          if (error.response && error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
        });
    },

    changeTemplateEvent(templateId) {
      if (!templateId || templateId == 0) {
        this.timeCount = 0;
        this.dayCount = 0;
        this.days = null;
        this.time = null;
        return;
      }

      if (templateId !== this.original_template_id) {
        this.isTemplateChanged = true;
      }

      this.subjectRows = new Array(7).fill([]).map(() => new Array(10).fill(""));
      this.teacherRows = new Array(7).fill([]).map(() => new Array(10).fill(""));
      this.teacherOptionsByCell = {};
      this.isLoading = true;
      this.getTimetableMetaByTemplate(templateId);
    },

    getTimetableMetaByTemplate(templateId) {
      this.isLoading = true;
      axios.get("/timetableMeta/getDataForTimetableByTemplate/" + templateId)
        .then((response) => {
          this.days = response.data.data[0];
          this.time = response.data.data[1];
          this.dayCount = this.days.length;
          this.timeCount = this.time.length;
          this.subjectRows = Array.from({ length: this.dayCount }, () =>
            Array.from({ length: this.timeCount }, () => "")
          );
          this.teacherRows = Array.from({ length: this.dayCount }, () =>
            Array.from({ length: this.timeCount }, () => "")
          );
          this.teacherOptionsByCell = {};
          this.selectedSubjects = this.subjectRows;
          this.isLoading = false;
        })
        .catch((error) => {
          if (error.response && error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
        });
    },

    getTimetableForEdit(classId) {
      this.isLoading = true;
      axios.get("/timetable/edit/" + classId)
        .then((response) => {
          if (response && response.data && response.data.status === 200) {
            const data = response.data.data;
            this.original_acd_year = data.acd_year_id;
            this.original_class_id = data.class_id;
            this.original_template_id = data.template_id;
            this.academic_year = data.period_name;
            this.class_name = data.class_name;
            this.template_id = data.template_id;

            this.days = data.days || [];
            this.time = data.times || [];
            this.dayCount = this.days.length;
            this.timeCount = this.time.length;
            this.timeTableData = data.timetable;

            this.getSubjectByClassId(classId);
            this.getTemplates();
          }
          this.isLoading = false;
        })
        .catch((error) => {
          if (error.response && error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
        });
    },

    getSubjectByClassId(classId) {
      axios.get("/class/subjectByClassId/" + classId, {
        params: {
          acd_year_id: this.original_acd_year,
          campus_id: store.state.user.campus_id
        }
      })
        .then((response) => {
          this.subjectArr = response.data.subjectArr ? (response.data.subjectArr[0] || []) : [];
          this.teacherMap = response.data.teacherMap || {};
          if (Array.isArray(this.timeTableData) && this.days && this.time) {
            this.buildCellMaps();
          }
          this.isLoading = false;
        })
        .catch((error) => {
          if (error.response && error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
        });
    },

    /**
     * Build the 2D arrays used to drive the subject/teacher dropdowns and
     * preload the teacher options for the existing subject_teacher_id values.
     */
    buildCellMaps() {
      const days = this.days || [];
      const times = this.time || [];
      this.subjectRows = Array.from({ length: days.length }, () =>
        Array.from({ length: times.length }, () => "")
      );
      this.teacherRows = Array.from({ length: days.length }, () =>
        Array.from({ length: times.length }, () => "")
      );
      this.teacherOptionsByCell = {};

      this.timeTableData.forEach((item) => {
        const rowIndex = days.findIndex(d => d.id == item.day_meta_id);
        const colIndex = times.findIndex(t => t.id == item.time_meta_id);
        if (rowIndex === -1 || colIndex === -1) return;
        if (item.subject_id) {
          this.$set(this.subjectRows[rowIndex], colIndex, item.subject_id);
        }
        if (item.subject_teacher_id) {
          this.$set(this.teacherRows[rowIndex], colIndex, item.subject_teacher_id);
          if (item.subject_id) {
            const baseOptions = this.teacherMap[item.subject_id] || [];
            const exists = baseOptions.some(o => String(o.id) === String(item.subject_teacher_id));
            const options = exists ? baseOptions : [...baseOptions, { id: item.subject_teacher_id, text: '(Saved teacher)' }];
            this.$set(this.teacherOptionsByCell, `${rowIndex}_${colIndex}`, options);
          }
        }
      });
      this.selectedSubjects = this.subjectRows;
    },

    getTeacherOptionsForCell(rowIndex, colIndex) {
      const key = `${rowIndex}_${colIndex}`;
      return this.teacherOptionsByCell[key] || [];
    },

    onSubjectChange(rowIndex, colIndex, selectedSubjectId) {
      this.$set(this.teacherRows[rowIndex], colIndex, '');
      this.subjectChangeCounter += 1;
      if (!selectedSubjectId || selectedSubjectId === '0' || selectedSubjectId === 0) {
        this.$set(this.teacherOptionsByCell, `${rowIndex}_${colIndex}`, []);
        return;
      }
      this.$set(this.teacherOptionsByCell, `${rowIndex}_${colIndex}`, this.teacherMap[selectedSubjectId] || []);
    },

    update() {
      this.isLoading = true;
      this.submitted = true;

      const preparedData = [];
      for (let rowIndex = 0; rowIndex < this.days.length; rowIndex++) {
        for (let columnIndex = 0; columnIndex < this.time.length; columnIndex++) {
          const dayId = this.days[rowIndex].id;
          const timeId = this.time[columnIndex].id;
          const subjectId = this.subjectRows[rowIndex][columnIndex];
          const subjectTeacherId = this.teacherRows[rowIndex] && this.teacherRows[rowIndex][columnIndex];
          const rowData = {
            day_id: dayId,
            time_id: timeId,
          };          
          if (subjectId !== undefined && subjectId !== '' && subjectId !== '0' && subjectId !== 0) {
            rowData.subject_id = subjectId;
          }
          if (subjectTeacherId !== undefined && subjectTeacherId !== '' && subjectTeacherId !== '0' && subjectTeacherId !== 0) {
            rowData.subject_teacher_id = subjectTeacherId;
          }
          preparedData.push(rowData);
        }
      }

      axios.put("/timetable/edit/" + this.original_class_id, {
        items: preparedData,
        class_id: this.original_class_id,
        template_id: this.template_id,
        original_template_id: this.original_template_id
      })
        .then(response => {
          this.isLoading = false;
          if (response.data && response.data.status == 200) {
            this.$notification.success(response.data.message || "Timetable updated successfully", {
              timer: 3,
              position: "bottomCenter"
            });
            this.$router.push({
              name: "timetableList"
            });
          } else {
            this.$notification.error(response.data.message || "Update failed. Please try again.", {
              timer: 3,
              position: "bottomCenter"
            });
          }
        })
        .catch(error => {
          this.isLoading = false;
          if (error.response) {
            if (error.response.status == 401) {
              this.$store.commit('logout');
              window.location.replace('login');
            } else {
              this.$notification.error(error.response.data.message || 'Update failed. Please try again.');
            }
          } else {
            this.$notification.error('Network error. Please try again.');
          }
        });
    },
  },

  mounted() {
    this.isLoading = true;
    const selectedClass = this.$route.params.id;
    this.getTimetableForEdit(selectedClass);

    // Watch subjectRows for changes (backup in case Select2 @change doesn't fire
    // on reselecting the same value after switching to a different subject).
    // Skips the initial load (rows that are being initialized have oldRows[r] undefined).
    this.$watch(
      () => this.subjectRows.map(row => row.slice()),
      (newRows, oldRows) => {
        if (!newRows || !newRows.length || !oldRows || !oldRows.length) return;
        for (let r = 0; r < newRows.length; r++) {
          if (!oldRows[r]) continue;
          for (let c = 0; c < newRows[r].length; c++) {
            const newVal = newRows[r][c];
            const oldVal = oldRows[r][c];
            if (newVal !== oldVal && newVal) {
              this.onSubjectChange(r, c, newVal);
            }
          }
        }
      },
      { deep: true }
    );
  },
};
